<h3 mat-dialog-title style="margin-bottom: 5px !important;">Emin misiniz?</h3>
<div mat-dialog-actions="">
    <div style="display: flex;justify-content: left;padding-top: 10px;padding-bottom: 10px;">
        <button mat-raised-button style="background-color: #359165;margin-right: 10px;color: white" (click)="rejectRequest(data)">Evet</button>
        <button mat-raised-button style="background-color: #f23637;color: white;" [mat-dialog-close]="data" cdkFocusInitial>Hayır</button>
    </div>
</div>
